import { render, staticRenderFns } from "./edit_task.vue?vue&type=template&id=55f45244"
import script from "./edit_task.vue?vue&type=script&lang=js"
export * from "./edit_task.vue?vue&type=script&lang=js"
import style0 from "./edit_task.vue?vue&type=style&index=0&id=55f45244&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports